export default "__VITE_ASSET__DegLgO68__"